/** Model of Error object received from BE in most API calls */
export interface ErrorDetails {
    message: string;
    statusCode?: number;
    translationCode?: string;
    translationParams?: Object;
}

/** Model of Error object returned from HttpErrorInterceptor */
export class ErrorWithTranslationCode extends Error implements ErrorDetails {
    public readonly statusCode?: number;

    public readonly translationCode?: string;

    public readonly translationParams?: Object;

    constructor(props: ErrorDetails) {
        super(props?.message);
        this.statusCode = props?.statusCode;
        this.translationCode = props?.translationCode;
        this.translationParams = props?.translationParams;
    }
}
